export const sceneLabel = sceneType => ({
  TRADITIONAL_FLOWER: "传统插花",
  LANDSCAPE: "园林景观",
  FLORAL_ENVIRONMENT: "花艺环境",
}[sceneType] || sceneType || "未设置");
